import Image1 from '@hotjar/shared-assets/images/integrations/slack/HotjarxSlack-Recordings.gif';
import Image2 from '@hotjar/shared-assets/images/integrations/slack/HotjarxSlack-Survey.gif';
import Image3 from '@hotjar/shared-assets/images/integrations/slack/Slack-incoming-feedback-integration.jpg';
import { IntegrationTokenName } from '../domains/api';
import type { Integration } from '../types';

export const slack: Integration = {
  slug: 'slack',
  icon: 'slack',
  name: 'integrations:slack.integrations-page.title',
  tokenName: IntegrationTokenName.Slack,
  provider: 'integrations:card.hotjar',
  actionLabel: {
    enable: 'integrations:details.header.slack-enable',
    disable: 'integrations:details.header.slack-disable',
  },
  description: 'integrations:slack.integrations-page.description-revamp',
  descriptionLarge: 'integrations:slack.integrations-page.description-large',
  resources: [
    {
      copy: 'integrations:slack.integrations-page.key-benefits',
      url: 'https://www.hotjar.com/integrations/slack/',
      icon: 'page_full',
    },
    {
      copy: 'integrations:slack.integrations-page.using-with-hotjar',
      url: '/articles/360048711313',
      icon: 'page_full',
    },
    {
      copy: 'integrations:details.resource.how-to-set-up-slack',
      url: 'https://learning.hotjar.com/videos/how-to-setup-the-slack-integration/',
      icon: 'recordings_old',
    },
    {
      copy: 'integrations:details.resource.how-to-send-feedback-slack',
      url: 'https://learning.hotjar.com/videos/how-to-send-feedback-responses-to-slack/',
      icon: 'recordings_old',
    },
  ],
  images: [Image1, Image2, Image3],
  videoUrl: 'https://www.youtube.com/embed/dffai7-6tlo',
  gate: 'core.integrations',
  isEnabled: false,
  settings: null,
};
